import { create } from "zustand";

export const useCompetenceStore = create((set, get) => ({
  // State
  competences: [],
  loading: false,
  error: null,
  selectedCompetence: null,
  searchQuery: "",
  filters: {},

  // Table features
  columnFilters: {},
  uniqueValues: {},
  paginationData: {
    currentPage: 1,
    itemsPerPage: 10,
    totalItems: 0,
    totalPages: 0,
  },

  // Modal / UI states
  isFormOpen: false,
  isEditMode: false,
  isDeleteDialogOpen: false,
  isPersonnelModalOpen: false,
  isAssignModalOpen: false,
  competenceToDelete: null,
  isDetailDialogOpen: false,
  competenceToView: null,

  // Basic Setters
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  clearError: () => set({ error: null }),

  setCompetences: (competences) => set({ competences }),
  setSelectedCompetence: (competence) => set({ selectedCompetence: competence }),

  setSearchQuery: (searchQuery) => set({ searchQuery }),
  setFilters: (filters) => set({ filters }),
  setColumnFilters: (columnFilters) => set({ columnFilters }),
  setUniqueValues: (uniqueValues) => set({ uniqueValues }),

  setPaginationData: (data) => set((state) => ({
    paginationData: {
      ...state.paginationData,
      ...data,
      currentPage: data.page || data.currentPage || state.paginationData.currentPage,
      itemsPerPage: data.pageSize || data.itemsPerPage || state.paginationData.itemsPerPage,
      totalItems: data.total || data.totalItems || state.paginationData.totalItems,
      totalPages: data.totalPages || state.paginationData.totalPages,
    }
  })),

  // UI Flow Actions
  openCreateForm: () => set({
    isFormOpen: true,
    isEditMode: false,
    selectedCompetence: null,
    error: null
  }),

  openEditForm: (competence) => set({
    isFormOpen: true,
    isEditMode: true,
    selectedCompetence: competence,
    error: null
  }),

  closeForm: () => set({
    isFormOpen: false,
    selectedCompetence: null,
    error: null
  }),

  openDeleteDialog: (competence) => set({
    isDeleteDialogOpen: true,
    competenceToDelete: competence,
    error: null
  }),

  closeDeleteDialog: () => set({
    isDeleteDialogOpen: false,
    competenceToDelete: null,
    error: null
  }),

  openPersonnelModal: (competence) => set({
    isPersonnelModalOpen: true,
    selectedCompetence: competence,
    error: null
  }),

  closePersonnelModal: () => set({
    isPersonnelModalOpen: false,
    selectedCompetence: null,
    error: null
  }),

  openAssignModal: (competence) => set({
    isAssignModalOpen: true,
    selectedCompetence: competence,
    error: null
  }),

  closeAssignModal: () => set({
    isAssignModalOpen: false,
    selectedCompetence: null,
    error: null
  }),

  openDetailDialog: (competence) => set({
    isDetailDialogOpen: true,
    competenceToView: competence,
    error: null
  }),

  closeDetailDialog: () => set({
    isDetailDialogOpen: false,
    competenceToView: null,
    error: null
  }),
}));
